/* eslint-disable no-unused-vars -- does not support ts */

import axios from '@/utils/axios'

import { camelCaseObjectKeysToSnakeCase, snakeCaseObjectKeysToCamelCase } from '@/utils/case-converter'
import { normalize } from './utils'
import type { RemotePrintSettings as TRemotePrintSettings } from '@/types/printing.model.js'

export const RemotePrintSettings = normalize({
  label: {
    showBeforePrint: true,
  },
  pickingList: {
    showBeforePrint: true,
    mode: 'full',
    itemSorting: [{ field: 'name', order: 'asc' }],
    hideFields: [],
  },
  packingSlip: {
    showBeforePrint: true,
  },
  customs: {
    printWithLabels: false,
    showBeforePrint: true,
    copies: 1,
  },
}) as (options?: Partial<TRemotePrintSettings>) => TRemotePrintSettings

export const defaults = () => RemotePrintSettings({})

/**
 * Save print options on server, returns the saves options
 */
export const save = async (options: Partial<TRemotePrintSettings>): Promise<TRemotePrintSettings> => {
  const allOptions = RemotePrintSettings(options)
  const request = camelCaseObjectKeysToSnakeCase(allOptions)
  const response = (await axios.put(`/orders/xhr/printing/settings`, request)).data
  const savedOptions = snakeCaseObjectKeysToCamelCase(response)
  return savedOptions as TRemotePrintSettings
}

/** @typedef {import('./utils.js').EmptyObject} EmptyObject */

/**
 * Get print options from server or empty if the user hasn't configured print settings before.
 * NOTE: the return type should actually be unknown instead of RemotePrintSettings | EmptyObject, but we trust that
 * the server will return a valid RemotePrintSettings object, so we don't do any parsing here;
 */
export const getAll = async (): Promise<TRemotePrintSettings | Record<string, never>> => {
  const response = (await axios.get(`/orders/xhr/printing/settings`)).data
  const savedOptions = snakeCaseObjectKeysToCamelCase(response)
  return savedOptions as TRemotePrintSettings
}
